import styled from 'styled-components';


const Border = styled.div`
    display: flex;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 2px solid #00273F;
    border-radius: 10px;
    height: 40px;
    align-items: center;
    margin: 10px 20px;
    cursor:pointer;
`;


export default Border;
